import { configureStore } from "@reduxjs/toolkit";
import weatherReducer from "@frontend/redux/weather/weatherSlice";
import { weatherPersistenceMiddleware } from "./weather/weatherPersistenceMiddleware";

const store = configureStore({
  reducer: {
    weatherReducer: weatherReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(weatherPersistenceMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
